import React, { useState } from 'react';
import { identity } from 'js/utils/ramda.util';
import ReactSlider from 'js/components/common/ReactSlider';

import style from './index.scss';

export const parseValue = value => Array.isArray(value) ? value : [value];

export const getMarkPositionStyle = (value, min, max) => {
    const offset = (value - min) / (max - min) * 100;
    return offset > 50
        ? { right: `${100 - offset}%` }
        : { left: `${offset}%` };
};

export const Marks = ({ format, marks = [], min, max, className = '' }) =>
    <div className={`${style.marks} ${className}`}>
        {marks.map((mark, i) => <div key={i}
            className={style.mark}
            style={getMarkPositionStyle(mark, min, max)}
        >
            {format(mark)}
        </div>)}
    </div>;

export const Labels = ({ format, value, className = '' }) => (
    <div className={`${style.labels} ${className}`}>
        {parseValue(value).map((v, i) => (
            <div key={i} className={style.label}>
                {format(v)}
            </div>
        ))}
    </div>
);

export const Range = (props) => {
    const {
        min = 0,
        max = 100,
        className,
        marksAfter,
        labelAfter,
        labelBefore,
        marksBefore,
        defaultValue,
        formatAfter = identity,
        formatBefore = identity,
        orientation = 'horizontal',
        ...other
    } = props;
    const orientationCls = style[orientation];
    const [value, setValue] = useState(parseValue(defaultValue));

    return (
        <div className={`${orientationCls} ${className}`}>
            {labelBefore && <Labels value={value} format={formatBefore} />}
            {marksBefore && (
                <Marks
                    min={min}
                    max={max}
                    marks={marksBefore}
                    format={formatBefore}
                />
            )}
            <ReactSlider
                min={min}
                max={max}
                value={value}
                onChange={setValue}
                barClassName={style.bar}
                className={style.slider}
                handleClassName={style.handle}
                handleActiveClassName={style.handleActive}

                {...other}
            >
                {
                    parseValue(value).map((v, i) => <div key={i} />)
                }
            </ReactSlider>
            {marksAfter && (
                <Marks
                    min={min}
                    max={max}
                    marks={marksBefore}
                    format={formatBefore}
                />
            )}
            {labelAfter && <Labels value={value} format={formatAfter} className={style.labelsAfter} />}
        </div>
    );
};

export const RangeSliderExample = () => (
    <Range
        defaultValue={2100}
        min={300}
        max={2100}
        step={300}
        pearling={false}
        minDistance={300}
        withBars={true}

        marksBefore={[300, 600, 2100]}
        marksAfter={[300, 1200, 2100]}
        formatBefore={x => `${x} pts`}
        formatAfter={x => `$${x / 300}`}

        labelBefore={true}
        labelAfter={true}
    />
);
